import type { HelpFile } from '../../types/help'
import { ResourcesTestIds } from '../../../testids/ResourcesTestIds'

export const resourcesHelp: HelpFile = {
  docPage: '/docs/systems/resources',
  texts: {
    [ResourcesTestIds.resourcesList]:
      'All resources defined across target systems — datasets, folders, applications, and other objects that access profiles are granted on.',
    [ResourcesTestIds.btnNewResource]:
      'Create a new resource of the locked type. Required attributes are derived from the type\u2019s attribute definitions.',
  },
}
